import React, { useContext } from 'react';
import { useFormContext , FormProvider } from 'react-hook-form';


const ConnectForm = ({ children }) => {
    const methods = useFormContext();

    return children({ ...methods });
};

const CustomFormContext = React.createContext();

const FormContext = ({ children, ...rest }) => {
    return (
        <FormProvider {...rest}>
            <CustomFormContext.Provider value={undefined}>
                {children}
            </CustomFormContext.Provider>
        </FormProvider>
    );
};

const useCustomFormContext = (props) => {
    const Form = useContext(CustomFormContext);
    return Form;
};

const withFormContext = (Component) => (props) => (
    <ConnectForm>
        {(methods) => <Component {...props} ref={methods.register} {...methods} />}
    </ConnectForm>
);

export {
    ConnectForm as default,
    CustomFormContext,
    FormContext,
    useCustomFormContext,
    withFormContext,
};
